



































import { Component, Prop, Vue } from "vue-property-decorator";
import Countdown from "@share/common/countdown/session-countdown/SessionCountdown.vue";

import { Carousel, Slide } from '@share/common/Carousel';
import { getImageUrl } from "@common/ImageUrlHelper";
import { Element } from "@api/models/Element";
import { detectMob } from "@common/mobileHelper";
import { Debounce } from "vue-debounce-decorator";

@Component({
  name: "PartnersList",
  components: { Countdown, Carousel, Slide },
})
export default class PartnersList extends Vue {
  /**
   * Data helper for data manipulation, comes from vuex store by date
   */
  @Prop({ required: true }) partners: Element[];

  getImageUrl = getImageUrl;

  isFirstPage = true;
  isLastPage = false;
  isMobile = false;
  perPage = 0;

  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.isMobile = detectMob();

    this.setPerPage(window.innerWidth)
  }

  setPerPage(windowWidth: number) {
    let perPage = 6;
    if(windowWidth < 480) {
      perPage = 2
    }
    else if(windowWidth < 768 || (windowWidth > 1023 && windowWidth < 1200)) {
      perPage = 4
    }

    this.perPage = this.partners.length >= perPage ? perPage : this.partners.length;
  }

  @Debounce(500)
  handleResize() {
    this.setPerPage(window.innerWidth);
  }

  slideClick(partner: Element) {
    this.$router.push({
      name: "Partner",
      params: { ...this.$route.params, schemaId: partner.schema || "", id: partner.id }
    })
  }

  onPageChanged(index: number) {
    this.isFirstPage = index == 0;
    this.isLastPage = index == (this.pagesNumber - 1);
  }

  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  }

  get edgeOffset() {
    return 0;
  }

  get pagesNumber() {
    if (this.perPage) {
      return Math.ceil(this.partners.length / this.perPage);
    }
    return 0;
  }

  get exhibitions() {
      return this.$store.getters['events/selectedEventExhibitions'];
  }
}
